import { toString30pk9tzaqopn as toString } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var AuthHookDataClass;
function AuthHookData() {
  if (AuthHookDataClass === VOID) {
    class $ {
      constructor(user, authenticated, loading, error, loginWithRedirect, getIdTokenClaims, logout, getAccessTokenSilently) {
        this.i3q_1 = user;
        this.j3q_1 = authenticated;
        this.k3q_1 = loading;
        this.l3q_1 = error;
        this.m3q_1 = loginWithRedirect;
        this.n3q_1 = getIdTokenClaims;
        this.o3q_1 = logout;
        this.p3q_1 = getAccessTokenSilently;
      }
      af() {
        return this.j3q_1;
      }
      q3q() {
        return this.k3q_1;
      }
      toString() {
        return 'AuthHookData(user=' + toString(this.i3q_1) + ', authenticated=' + this.j3q_1 + ', loading=' + this.k3q_1 + ', error=' + toString(this.l3q_1) + ', loginWithRedirect=' + toString_0(this.m3q_1) + ', getIdTokenClaims=' + toString_0(this.n3q_1) + ', logout=' + toString_0(this.o3q_1) + ', getAccessTokenSilently=' + toString_0(this.p3q_1) + ')';
      }
      hashCode() {
        var result = this.i3q_1 == null ? 0 : hashCode(this.i3q_1);
        result = imul(result, 31) + getBooleanHashCode(this.j3q_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.k3q_1) | 0;
        result = imul(result, 31) + (this.l3q_1 == null ? 0 : hashCode(this.l3q_1)) | 0;
        result = imul(result, 31) + hashCode(this.m3q_1) | 0;
        result = imul(result, 31) + hashCode(this.n3q_1) | 0;
        result = imul(result, 31) + hashCode(this.o3q_1) | 0;
        result = imul(result, 31) + hashCode(this.p3q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AuthHookData()))
          return false;
        if (!equals(this.i3q_1, other.i3q_1))
          return false;
        if (!(this.j3q_1 === other.j3q_1))
          return false;
        if (!(this.k3q_1 === other.k3q_1))
          return false;
        if (!equals(this.l3q_1, other.l3q_1))
          return false;
        if (!equals(this.m3q_1, other.m3q_1))
          return false;
        if (!equals(this.n3q_1, other.n3q_1))
          return false;
        if (!equals(this.o3q_1, other.o3q_1))
          return false;
        if (!equals(this.p3q_1, other.p3q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'AuthHookData');
    AuthHookDataClass = $;
  }
  return AuthHookDataClass;
}
//region block: exports
export {
  AuthHookData as AuthHookData2x0lxghdz8ao,
};
//endregion

//# sourceMappingURL=AuthHookData.mjs.map
